import {useCallback, useEffect, useState} from "react";

import {checkEmptyFilterFields} from "../checkEmptyFilterFields";

const useSessionFilters = filtersKey => {
  // const [filters, setFiltrs] = useState(getFilters());

  // useEffect(() => {
  //   setFiltrs(getFilters());
  // }, []);

  // const getFilters = () => {
  //   let parsedValue = null;
  //   try {
  //     parsedValue = JSON.parse(sessionStorage.getItem(filtersKey));
  //   } catch (error) {
  //     console.error(error);
  //   }
  //   return parsedValue;
  // };
  // const filters = useRef(getFilters());
  // const setFilters = value => sessionStorage.setItem(filtersKey, JSON.stringify(checkEmptyFilterFields(value)));
  // const clearFilters = () => sessionStorage.removeItem(filtersKey);

  // const initialFilters = useMemo(() => getFilters() || null, []);
  // return {filters, setFilters, clearFilters, initialFilters};

  const readFilters = useCallback(() => {
    if (typeof window === "undefined") return null;

    try {
      const raw = sessionStorage.getItem(filtersKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.error("Failed to parse session filters:", e);
      return null;
    }
  }, [filtersKey]);

  const [filters, setFiltersState] = useState(() => readFilters());

  useEffect(() => {
    setFiltersState(readFilters());
  }, [readFilters]);

  const setFilters = useCallback(
    value => {
      const cleaned = checkEmptyFilterFields(value);
      setFiltersState(cleaned);
      sessionStorage.setItem(filtersKey, JSON.stringify(cleaned));
    },
    [filtersKey],
  );

  const clearFilters = useCallback(() => {
    setFiltersState(null);
    sessionStorage.removeItem(filtersKey);
  }, [filtersKey]);

  return {filters, setFilters, clearFilters, initialFilters: filters};
};

export default useSessionFilters;
